<template>
</template>

<script>
    import StripeMixins from 'mixins/StripeMixins';
    import Env from 'Services/Env';

    export default {
        mixins: [StripeMixins],
        props: {
            thirdid: {
                type: String,
                required: true
            },
            paymentIntent: {
                type: String,
                required: true
            },
            lang: {
                type: String,
                required: true
            }
        },

        data(){
            return {
                publishableKey: Env.get('stripe').publishableKey,
            };
        },

        computed: {
            stripe() {
                return window.Stripe(this.publishableKey, this.lang);
            }
        },
        methods: {
            stripeInitElements(){
                this.stripe.handleCardPayment(this.paymentIntent).then(function(result) {
                    if (result.error) {
                        Push.error(result.error.message);
                        _.delay(function() { Utils.relocate("/"); }, 3000);
                    } else {
                        // The payment has succeeded. Display a success message.
                        Utils.relocate("/");
                    }
                });
            }
        },
    }
</script>